import Vue from 'vue';
import router from './router';
import store from './store';

import './plugins/element.js';
import htmlToPdf from '@/until/htmlToPdf.js';

import App from './App.vue';

Vue.config.productionTip = false;

Vue.use(htmlToPdf);
new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
